import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {center} from '../../styles/mixins';
import {Layer} from '../layers/layer';
import {PopoverProps} from './popoverTypes';

/*
 * Props.
 */

export interface CenteredPopoverProps extends PopoverProps {
  shouldPreventHorizontalOverflow?: boolean;
}

interface StyledCenteredPopoverProps {
  $shouldPreventHorizontalOverflow?: CenteredPopoverProps['shouldPreventHorizontalOverflow'];
}

/*
 * Style.
 */

const maybeSetMaxWidth = (props: StyledCenteredPopoverProps) =>
  props.$shouldPreventHorizontalOverflow &&
  css`
    max-width: 100%;
  `;

const StyledCenteredDiv = styled.div<StyledCenteredPopoverProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  ${center()};
`;

const StyledBackgroundDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.theme.modalBackdrop};
`;

const StyledContentDiv = styled.div<StyledCenteredPopoverProps>`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  ${maybeSetMaxWidth}

  pointer-events: none;
  & > * {
    pointer-events: all;
  }
`;

/*
 * Component.
 */

export const CenteredPopover: FC<CenteredPopoverProps> = (props) => (
  <Layer {...props}>
    <StyledCenteredDiv>
      <StyledBackgroundDiv onClick={props.onRequestClose} />
      <StyledContentDiv $shouldPreventHorizontalOverflow={props.shouldPreventHorizontalOverflow}>
        {props.children}
      </StyledContentDiv>
    </StyledCenteredDiv>
  </Layer>
);
